import { render, staticRenderFns } from "./SideMenuAlert.vue?vue&type=template&id=5181bd2b&scoped=true&"
import script from "./SideMenuAlert.vue?vue&type=script&lang=ts&"
export * from "./SideMenuAlert.vue?vue&type=script&lang=ts&"
import style0 from "./SideMenuAlert.vue?vue&type=style&index=0&id=5181bd2b&lang=scss&scoped=true&"
import style1 from "./SideMenuAlert.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5181bd2b",
  null
  
)

export default component.exports